import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService } from 'primeng/api';
import { } from 'primeng/messages';
import { MessagesModule } from 'primeng/messages';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';

//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { ToastModule } from 'primeng/toast';

// Vertical Layout
import { SidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { HeaderComponent } from './layouts/full/header/header.component';
import { BrandingComponent } from './layouts/full/sidebar/branding.component';
import { AppNavItemComponent } from './layouts/full/sidebar/nav-item/nav-item.component';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { FloatLabelModule } from 'primeng/floatlabel';
import { AuthInterceptor } from './utilities/auth.interceptor';
import { CertificateComponent } from './pages/dashboard/certificate/certificate.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SafeHtmlize } from './layouts/pipe/htmlize/safe-html.pipe';
import { MatIconModule } from '@angular/material/icon';
import { PaymentInterceptor } from './utilities/interceptors/payment.interceptor';
import { PaymentPopupComponent } from './pages/ui-components/shared/payment-popup/payment-popup.component';
import { BreadcrumbsComponent } from './layouts/full/breadcrumbs/breadcrumbs.component';
import { MiniplayerComponent } from './layouts/full/miniplayer/miniplayer.component';
@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    BlankComponent,
    SidebarComponent,
    HeaderComponent,
    BrandingComponent,
    AppNavItemComponent,
    BreadcrumbsComponent,
    MiniplayerComponent,
    SafeHtmlize
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AvatarModule,
    NgxSpinnerModule.forRoot(),
    TablerIconsModule.pick(TablerIcons),
    NgScrollbarModule,
    MessagesModule,
    RippleModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    ToastModule,
    FloatLabelModule,
    ChartModule,
    OverlayPanelModule,
    MatIconModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [TablerIconsModule, SafeHtmlize],
  bootstrap: [AppComponent],
  providers: [MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: PaymentInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AppModule { }
